module.exports = __webpack_public_path__ + "static/media/06.549d6002.png";